export const getClosingStatus = (details, now = Date.now()) => {
  const hours = details?.opening_hours;
  if (!hours) return null;
  const open = hours.isOpen?.(new Date(now)) ?? hours.open_now;
  if (!open) return { open: false };

  const nextClose = (hours.periods || [])
    .map(period => period.close?.nextDate)
    .filter(value => Number.isFinite(value) && value > now)
    .sort((a, b) => a - b)[0];
  if (!nextClose) return { open: true, alwaysOpen: hours.periods?.some(period => !period.close) };

  const minutes = Math.ceil((nextClose - now) / 60000);
  const offset = details.utc_offset_minutes;
  const time = Number.isFinite(offset)
    ? new Date(nextClose + offset * 60000).toISOString().slice(11, 16)
    : new Date(nextClose).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  return { open: true, closingSoon: minutes <= 90, minutes, time };
};

export const getWaitMentions = reviews => (reviews || []).filter(review =>
  /(排隊|候位|等位|等座|等候.{0,8}(分鐘|小時)|等了.{0,8}(分鐘|小時)|queue|wait(?:ed|ing)? .{0,16}(table|seat|minute|hour))/i.test(review.text || '')
).length;
